import React from 'react';
import CrossIcon from '../../assets/CrossIcon';
import { IPaxDriverAllocation } from '../../interfaces/driverPaxAllocation';
import { translate } from '../../i18n';

interface UnallocatedProps<T> {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  heading: string;
  data?: T[];
}

const UnallocatedCard = <T extends IPaxDriverAllocation>({
  isVisible,
  setIsVisible,
  heading,
  data,
}: UnallocatedProps<T>) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-background m-10 w-full max-w-md text-textColorGray rounded-lg shadow-lg p-4  sm:mx-8 relative">
        <div className="flex justify-between items-center mb-4 border-b pb-2">
          <h2 className="text-sm font-bold text-textColor font-Inter text-nowrap">
            {heading}
          </h2>
          <button
            onClick={() => setIsVisible(false)}
            className="text-red-500 text-xl font-bold"
          >
            <CrossIcon />
          </button>
        </div>
        {data && data?.length > 0 ? (
          <ul className="space-y-2 max-h-[50vh] overflow-y-auto">
            {data?.map((passenger, index) => (
              <li
                key={index}
                className="flex justify-between items-center border-b pb-2 text-textColorGray text-sm"
              >
                <span className="text-xs">{passenger?.paxName}</span>
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-center ">
            {translate('common.unAllocatedMessage')}
          </p>
        )}
      </div>
    </div>
  );
};

export default UnallocatedCard;
